import { render } from "./Statement.vue?vue&type=template&id=5eb2c324&scoped=true"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"

import "./Statement.vue?vue&type=style&index=0&id=5eb2c324&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5eb2c324"

export default script